import { Link } from '@/components/Elements';

import NoResults from '@/components/Elements/NoResults/NoResults';
import { Button } from '@/components/ui/elements/button';
import { ButtonGroup } from '@/components/ui/elements/button-group';
import useNotificationStore from '@/stores/notifications';
import { cn } from '@/utils/format';
import { CheckIcon, TrashIcon } from '@heroicons/react/24/solid';
import { formatDistanceToNow } from 'date-fns';
import { useShallow } from 'zustand/react/shallow';

export const NotificationsStack = () => {
  const { notifications, markAsRead, markAllAsRead, deleteNotification, clearAll } =
    useNotificationStore(
      useShallow((state) => ({
        markAllAsRead: state.markAllAsRead,
        markAsRead: state.markAsRead,
        notifications: state.notifications,
        deleteNotification: state.delete,
        clearAll: state.clear,
      })),
    );

  return (
    <>
      <ButtonGroup className="my-3 mx-auto">
        <Button
          className={cn(!notifications.length ? 'text-foreground/50' : 'text-foreground/95')}
          onClick={markAllAsRead}
          variant="outline"
          size="sm"
          disabled={!notifications.length}
        >
          Mark All As Read
        </Button>
        <Button
          className={cn(!notifications.length ? 'text-foreground/50' : 'text-foreground/95')}
          onClick={clearAll}
          variant="outline"
          size="sm"
          disabled={!notifications.length}
        >
          Delete All
        </Button>
      </ButtonGroup>
      <ul role="list" className="flex flex-col divide-y h-full overflow-y-auto">
        {!notifications.length && <NoResults label="notifications" />}

        {notifications.map((notification) => (
          <li key={notification.id} className="flex items-center justify-between gap-x-6 py-4 px-4">
            <div className="min-w-0">
              <div className="flex items-start gap-x-3">
                {!notification.link ? (
                  <p
                    className={cn(
                      'text-sm leading-6 ',
                      notification.read
                        ? 'font-normal text-foreground/50 italic'
                        : 'font-semibold text-foreground/95',
                    )}
                  >
                    {notification.title}
                  </p>
                ) : (
                  <Link
                    to={notification.link}
                    className={cn(
                      'text-sm leading-6 ',
                      notification.read
                        ? 'font-normal text-foreground/50 italic'
                        : 'font-semibold text-foreground/95',
                    )}
                  >
                    {notification.title}
                  </Link>
                )}
              </div>
              <div className="mt-1 flex flex-col gap-y-1 text-xs leading-5 text-foreground/50">
                <p>Received {formatDistanceToNow(notification.id)} ago</p>
                <p>{notification.message}</p>
              </div>
            </div>
            <div className="flex flex-none items-center gap-x-4">
              <ButtonGroup>
                {!notification.read && (
                  <Button variant="icon" onClick={() => markAsRead(notification.id)}>
                    <CheckIcon />
                  </Button>
                )}
                <Button variant="icon" onClick={() => deleteNotification(notification.id)}>
                  <TrashIcon />
                </Button>
              </ButtonGroup>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};
